import React, { useState } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import AmSatelliteTilePlotMap from "./AmSatelliteTilePlotMap";
import { useTranslation } from "react-i18next";
import useMapLoading from "../../hooks/useMapLoading";

const AmAdvancedMaps = ({ tile, polygon }) => {
  const { t } = useTranslation();
  const tileKeys = Object.keys(tile).slice(2);
  const [selectedTile, setSelectedTile] = useState(tileKeys[0] || "");
  const { isLoading, setIsLoading, MapEventsHandler } = useMapLoading();

  return (
    <>
      <FormControl fullWidth sx={{ mt: 1.5, mb: "5px" }}>
        <InputLabel id="tile-select-label">{t("Select Tile")}</InputLabel>
        <Select
          labelId="tile-select-label"
          value={selectedTile}
          label={t("Select Tile")}
          onChange={(e) => setSelectedTile(e.target.value)}
        >
          {tileKeys.map((key) => (
            <MenuItem key={key} value={key}>
              {key.toUpperCase()}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedTile && (
        <Box
          sx={{
            zIndex: 1001,
            padding: "5px 10px",
            borderRadius: 1,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            position: "relative",
            top: "auto",
            left: "auto",
          }}
          fullWidth
        >
          {isLoading && (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <CircularProgress size={40} />
              <Typography variant="body2" mt={1}>
                {`${t("Loading satellite imagery")}...`}
              </Typography>
            </Box>
          )}
          <AmSatelliteTilePlotMap
            tile={tile}
            polygon={polygon}
            activeTile={selectedTile}
            MapEventsHandler={MapEventsHandler}
            setIsLoading={setIsLoading}
          />
        </Box>
      )}
    </>
  );
};

export default AmAdvancedMaps;
